export const ALARMS_PATH = "AlarmsLogModule";

export const ALARMS_PAGE_LOG_PATH = `${ALARMS_PATH}/Log`;